module.exports = __webpack_public_path__ + "media/images/front/home_3-e398774b279c8d90ebddfc5040432d55.webp";